import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { TemplateOfferingDetailsMeetingRoom } from "../template_offering_details_meeting_room";
import { useTheYardAnalytics } from "./theyard_analytics";
import { generalInfo, partnerConfig } from "./theyard_partner_config";

const Theme = lazyWithRetry(() => import("./theyard_theme"));

const faqs = [
  {
    question: "Is there high speed wifi?",
    answer: "The Yard provides reliable, high-speed wireless internet.",
  },
  {
    question: "Are there complimentary refreshments?",
    answer:
      "Modern kitchens include complimentary coffee by La Colombe and tea by Kusmi Tea.",
  },
];

export function OfferingTheYardMeetingRoom() {
  useTheYardAnalytics();

  return (
    <Fragment>
      <Theme />
      <TemplateOfferingDetailsMeetingRoom
        showAddress
        showDirections
        partnerConfig={partnerConfig}
        data={{
          faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
